import { render, staticRenderFns } from "./PersonalityDetailsIcon.vue?vue&type=template&id=64d49a16&"
import script from "./PersonalityDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./PersonalityDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports